import { useConductricsSelection } from '@dx-ui/framework-conductrics';

const useUsernameFieldTest = () => {
  const { selection, isLoaded: isUsernameFieldTestLoaded } = useConductricsSelection('a-auth-697');
  const showUsernameField = isUsernameFieldTestLoaded && selection?.choice === 'B';
  return { showUsernameField, isUsernameFieldTestLoaded };
};

export default useUsernameFieldTest;
